module.exports = __webpack_public_path__ + "ic-insights-sales.svg?a66f0d53e2951e15a6207828082e6e80";